<template xmlns='http://www.w3.org/1999/html'>
  <div class='mainContainer'>
    <div class='nav'>
      <div class='navContainer' style='width: 230px'>
        <p>港口名称：</p>
        <el-input v-model='entrustIpt' size='mini' style='width:150px' placeholder='请输入委托商名称' />
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>作业类型：</p>
        <el-select v-model='typeIpt' size='mini' filterable style='width:150px'
                   placeholder='请选择作业类型'>
          <el-option label='全部' value='' />
          <el-option label='翻仓' value='1' />
          <el-option label='加油' value='2' />
          <el-option label='塔电' value='3' />
          <el-option label='加气' value='4' />
          <el-option label='洗车' value='5' />
        </el-select>
      </div>
      <div class='navContainer'>
        <p>状态：</p>
        <el-select v-model='stateIpt' size='mini' filterable style='width:150px'
                   placeholder='请选择状态'>
          <el-option v-for='item in stateOption' :key='item.label' :label='item.label'
                     :value='item.value' />
        </el-select>
      </div>
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        <el-button size='small' type='primary' @click='addBtn'>新增</el-button>
        <el-button size='small' type='primary' @click='batchEnable'>启用</el-button>
      </div>
    </div>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          ref='tableRef'
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
          @selection-change='selectionChange'>
          <el-table-column type='selection' align='center' width='55' :reserve-selection='true'
                           :selectable='(row)=>{return row.status === 0}'></el-table-column>
          <el-table-column label='序号' align='center' width='50px' type='index' />
          <el-table-column label='港口名称' align='center' prop='portName'>
          </el-table-column>
          <el-table-column label='作业类型' align='center' width='80px' type='index'>
            <template slot-scope='scope'>
              <span>{{ getWorkType(scope.row.workType) }}</span>
            </template>
          </el-table-column>
          <!--          <el-table-column prop="customerCarName" label="适配车型" show-overflow-tooltip-->
          <!--                           align="center"/>-->
          <el-table-column prop='startDate' label='开始时间' align='center' width='150px' />
          <el-table-column prop='endDate' label='结束时间' align='center' width='150px' />
          <el-table-column prop='taxRate' label='税率%' align='center' />
          <el-table-column prop='unitPrice' label='单价' align='center' />
          <el-table-column prop='createTime' label='创建时间' show-overflow-tooltip width='150'
                           align='center' >
            <template slot-scope='scope'>{{ scope.row.createTime|getCreatTime }}</template>
          </el-table-column>
          <el-table-column prop='createByName' label='录入人员' show-overflow-tooltip width='150'
                           align='center' />
          <el-table-column prop='status' label='状态' align='center'>
            <div slot-scope='scope'>{{ getState(scope.row.status) }}</div>
          </el-table-column>
          <el-table-column label='操作' width='360' align='center'>
            <template slot-scope='scope'>
              <div style='display:flex;align-items:center;padding-left: 10px'>
                <el-button size='mini' class='searchBtn' type='primary'
                           @click='detailClick(scope.row.id)'>详情
                </el-button>
                <el-button v-if='!scope.row.status' size='mini' :loading='changeLoad'
                           class='yellow-bg' type='primary' @click='changeClick(scope.row)'>修改
                </el-button>
                <el-button v-if='!scope.row.status' size='mini' type='primary'
                           @click='enableClick(scope.row)'>启用
                </el-button>
                <el-button v-if='scope.row.status===1' size='mini' type='danger'
                           @click='disableClick(scope.row)'>停用
                </el-button>
                <el-button v-if='scope.row.status==0 || scope.row.status==2' size='mini' type='info'
                           @click='deleteClick(scope.row.id)'>删除
                </el-button>
                <el-button size='mini' class='yellow-bg' type='danger' @click='recordBtn(scope.row)'>补录合同</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='sizes,prev, pager, next,jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          @prev-click='contractCurrentChange'
          @next-click='contractCurrentChange'
        />
      </div>
    </div>
    <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' width='650px' center
               @close='dialogClose' :close-on-click-modal='false'>
      <div class='depart'>
        <el-form :model='companyData' label-width='100px' :rules='rules' ref='ruleForm'>
          <div-border label='基础信息' divStyle='margin-top: 10px;'>
            <el-row>
              <el-col>
                <el-form-item label='港口名称：' style='margin-top: 10px'
                              prop='name'>
                  <el-select v-model='companyData.name' value-key='id'
                             :disabled="dialogTitle=='修改港口价格'" filterable size='small'
                             style='width:100%' placeholder='请选择港口'>
                    <el-option v-for='item in nameOption' :key='item.id' :label='item.supplier_name'
                               :value='item' />
                  </el-select>
                </el-form-item>
                <el-form-item label='作业类型：' style='margin-top: 10px'
                              prop='taskType'>
                  <el-select v-model='companyData.taskType' value-key='id' @change='nameChange'
                             filterable size='small' :disabled="dialogTitle=='修改港口价格'"
                             style='width:100%'
                             placeholder='请选择作业类型'>
                    <el-option v-for='item in typeTask' :key='item.value' :label='item.lable'
                               :value='item.value' />
                  </el-select>
                </el-form-item>
                <!--                <el-form-item label="适配车型：" style="margin-bottom: 0" class="model-item" prop="model">-->
                <!--                  &lt;!&ndash; <span style="margin-right: 5px;" v-for="(item,index) in selectedCar">{{item.name}}<span v-if="index!==selectedCar.length-1">、</span></span>-->
                <!--                  <span style="color: rgba(51, 136, 255, 1);cursor: pointer;" @click="carClick">点击选择车辆</span> &ndash;&gt;-->
                <!--                  <el-cascader-->
                <!--                    :disabled="dialogTitle=='修改港口价格'"-->
                <!--                    v-model="companyData.model"-->
                <!--                    size="mini" collapse-tags-->
                <!--                    style="width: 100%"-->
                <!--                    :options="modelOption"-->
                <!--                    :props="{ value:'id', label:'model', children:'carModel', multiple: true }"-->
                <!--                    clearable filterable/>-->
                <!--                </el-form-item>-->
                <el-row :gutter='24'>
                  <el-col :span='12'>
                    <el-form-item label='有效期始：' prop='start' style='margin-bottom: 20px'>
                      <el-date-picker
                        :disabled="dialogTitle=='修改港口价格'"
                        v-model='companyData.start'
                        size='small'
                        type='datetime'
                        style='width:100%'
                        value-format='yyyy-MM-dd HH:mm:ss'
                        placeholder='请选择有效开始时间' />
                    </el-form-item>
                  </el-col>
                  <el-col :span='12'>
                    <el-form-item label='结束日期：' prop='end'>
                      <el-date-picker
                        :disabled="dialogTitle=='修改港口价格'"
                        v-model='companyData.end'
                        size='small'
                        type='datetime'
                        style='width:100%'
                        value-format='yyyy-MM-dd HH:mm:ss'
                        placeholder='请选择有效结束时间' />
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div-border>
          <div-border label='其他' divStyle='margin-top: 10px;'>
            <el-row>
              <el-col>
                <el-form-item label='税率：' prop='rate' style='margin-top: 10px'>
                  <el-input
                    type='number'
                    :style="'width:100%'"
                    v-model='companyData.rate'
                    placeholder='请输入税率'
                    autocomplete='off'
                    size='small'>
                    <span slot='suffix' style='color: #999'>|  %</span>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label='单价：' prop='ratec'>
              <!--              <span style="margin-left: -469px;">每：</span>-->
              <!--              <el-col :span="11" style="margin-left: 28px;">-->
              <!--                <el-form-item prop="number">-->
              <!--                  <el-input-->
              <!--                    type="number"-->
              <!--                    :style="'width:150px'"-->
              <!--                    v-model="companyData.number"-->
              <!--                    placeholder="请输入数量"-->
              <!--                    autocomplete="off"-->
              <!--                    size="small">-->
              <!--                  </el-input>-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->
              <el-col :span='11'>
                <el-form-item prop='money'>
                  <el-input
                    type='number'
                    :style="'width:150px'"
                    prop='money'
                    v-model='companyData.money'
                    placeholder='请输入费用'
                    autocomplete='off'
                    size='small'>
                  </el-input>
                </el-form-item>
              </el-col>
              <span style='margin-left: -61px;'>元</span>&nbsp;&nbsp;<el-input
              :style="'width: 50px;'" size='small' v-model='company' disabled
              draggable='false'></el-input>
            </el-form-item>
          </div-border>
          <div class='btnContainer'>
            <el-button size='medium' class='searchBtn' :loading='btnLoad' @click='addClick'>确定
            </el-button>
            <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title='详情' :visible.sync='detailDialogVisible' width='600px' center top='10vh'>
      <div class='detail'>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>基础信息</span>
          </div>
          <div class='baseInfoContent'>
            <div class='baseInfoContentItem'>
              <span class='span1'>港口名称：</span>
              <span>{{ supplier_name }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>作业类型：</span>
              <span>{{ getWorkType(companyData.taskTypes) }}</span>
            </div>
            <!--            <div class="baseInfoContentItem">-->
            <!--              <span class="span1">适配车型：</span>-->
            <!--              <span>{{companyData.model}}</span>-->
            <!--            </div>-->
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>有效期始：</span>
                <span>{{ companyData.starts }}</span>
              </div>
              <div>
                <span class='span1'>结束时间：</span>
                <span>{{ companyData.ends }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>其他</span>
          </div>
          <div class='baseInfoContent'>
            <div class='baseInfoContentItem'>
              <span class='span1'>税率：</span>
              <span>{{ companyData.rate }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>单价：</span>
              <span>{{ companyData.money
                }}&nbsp;&nbsp;<span>元/<span>{{ company }}</span></span></span>
            </div>
          </div>
        </div>
        <div class='operation'>
          <div class='operationTitle'>
            <div class='line' />
            <span>补录合同</span>
          </div>
          <div class='operationTable'>
            <el-table :data='companyData.contractData' border
                      :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B',height:'35px'}">
              <el-table-column type='index' label='序号' width='50' align='center'></el-table-column>
              <el-table-column property='codeNumber' label='合同编号' min-width='150' align='center' />
              <el-table-column property='contractName' label='合同名称' min-width='150' align='center' />
              <el-table-column property='typeName' label='合同类型' min-width='100' align='center' />
              <el-table-column property='rate' label='税率' min-width='150' align='center' />
              <el-table-column property='' label='含税合同价' min-width='150' align='center' />
              <el-table-column property='' label='不含税合同价' min-width='150' align='center' />
              <el-table-column property='startDate' label='开始日期' min-width='100' :formatter='getDate'
                               align='center' />
              <el-table-column property='endDate' label='结束日期' min-width='100' :formatter='getDate'
                               align='center' />
              <el-table-column width='200px' label='操作' align='center' fixed='right'>
                <template slot-scope='scope'>
                  <el-button type='danger' size='small' @click='deleteTableClick(scope.row.id)'>删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!--        <div class="operation">-->
        <!--          <div class="operationTitle">-->
        <!--            <div class="line"/>-->
        <!--            <span>适配车型</span>-->
        <!--          </div>-->
        <!--          <div class="operationTable">-->
        <!--            <el-table :data="companyData.modelLists" border>-->
        <!--              <el-table-column type="index" label="序号" align="center"/>-->
        <!--              <el-table-column prop="brandName" label="品牌" align="center"/>-->
        <!--              <el-table-column prop="modelName" label="型号" align="center"/>-->
        <!--              <el-table-column label="状态" align="center" width="160px">-->
        <!--                <div slot-scope="scope">{{ getState(scope.row.status) }}</div>-->
        <!--              </el-table-column>-->
        <!--            </el-table>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class='operation'>
          <div class='operationTitle'>
            <div class='line' />
            <span>操作信息</span>
          </div>
          <div class='operationTable'>
            <el-table :data='companyData.operateRecordList' border>
              <el-table-column label='操作时间' align='center' width='160px'>
                <div slot-scope='scope'>{{ getTime(scope.row.createTime) }}</div>
              </el-table-column>
              <el-table-column prop='operateType' label='操作类型' align='center' />
              <el-table-column prop='operationName' label='操作人' align='center' />
              <el-table-column prop='remark' label='备注' align='center' />
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import steps from '@/components/steps';
  import { formatDateTime } from '@/config/mUtils';
  import divBorder from '@/components/divBorder';
  import {
    supplierPortOtherupdateStatus,
    supplierPortOtherdelete,
    supplierPortOtherupdate,
    supplierPortOtherdetail,
    supplierPortOtherpageList,
    supplierPortOtheradd,
    getCarSerieList,
    portConfigureDetail, deletePortConfigure,
    getTypeInfo,
    contractPageList, enablePortConfigure, getContractInfo, deleteContractInfo,
  } from '@/service/financial';
  import { supplierPublicSelectPort } from '@/service/vehiclelog';
  // import {supplierPortOtherdetail} from "../../../service/financial";

  export default {
    components: {
      steps,
      divBorder,
    },
    data() {
      return {
        company: '',
        zbId: '',
        supplier_name: '',
        type: '',
        carModelSz: [],
        money: '',
        taskType: '',
        number: '',
        entrustIpt: '',
        typeIpt: '',
        stateIpt: '',
        stateOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 0,
            label: '待生效',
          },
          {
            value: 1,
            label: '生效中',
          },
          {
            value: 2,
            label: '已失效',
          },
        ],
        page: 1,
        size: 10,
        total: 0,
        tableLoad: false,
        TableDatas: [],
        detailDialogVisible: false,
        detailData: {},
        dialogVisible: false,
        dialogTitle: '',
        nameOption: [],
        payOption: [],
        modelOption: [],
        modelMap: new Map(),
        brandMap: new Map(),
        addressOption: [],
        typeTask: [{
          value: 1,
          lable: '翻仓',
        }, {
          value: 2,
          lable: '加油',
        }, {
          value: 3,
          lable: '搭电 ',
        }, {
          value: 4,
          lable: '加气',
        }, {
          value: 5,
          lable: '洗车',
        }],
        companyData: {
          priceType: 1,
          model: [],
        },
        rules: {
          start: [{
            required: true,
            message: '请选择有效时间',
            trigger: 'change',
          }],
          end: [{
            required: true,
            message: '请选择结束时间',
            trigger: 'change',
          }],
          name: [
            {
              required: true,
              message: '请选择委港口',
              trigger: 'change',
            },
          ],
          taskType: [
            {
              required: true,
              message: '请选择作业类型',
              trigger: 'change',
            },
          ],
          number: [
            {
              required: true,
              message: '请输入数量',
              trigger: 'blur',
            },
          ],
          money: [
            {
              required: true,
              message: '请输入费用',
              trigger: 'blur',
            },
          ],
          rate: [
            {
              required: true,
              message: '请输入税率',
              trigger: 'blur',
            },
          ],
          model: [
            {
              required: true,
              message: '请选择适配类型',
              trigger: 'blur',
            },
          ],
        },
        carVisible: false,
        selectedCar: [],
        selectCar: [],
        brands: [],
        models: [],
        brands2: [],
        models2: [],
        selectBrand: [],
        selectModel: [],
        allCar: [],
        allModel: [],
        btnLoad: false,  // 新增/修改 确认按钮状态
        changeLoad: false, //修改按钮状态

        // 结算价格设置弹窗 数据
        priceSetForm: {
          type: 0,
          price: '',
        },
        priceSetVisible: false,
        // 合同编号弹窗 数据
        condition: {
          codeNumber: '',
          contractName: '',
          companyName: '',
        },
        //总数据条数
        total1: 0,
        //当前页数
        page1: 1,
        //每页显示多少条数据
        rows1: 10,
        contractLoad: false,
        contractData: [],
        selectContract: {
          codeNumber: '',
          companyName: '',
          startDate: '',
          endDate: '',
        },
        // 阶梯
        dialogShow: false,
        waterPriceData: {
          DataTable: [
            {
              startNum: '0',
              endNum: '',
              contractPrice: '',
            },
          ],
        },
        checkTableData: [],
      };
    },
    computed: {
      stepState() {
        return function(state) {
          switch (state) {
            case '':
              return 'wait';
            case 'success':
              return 'success';
            case 'failure':
              return 'error';
          }
        };
      },
      getWorkType() {
        return function(state) {
          switch (state) {
            case 1:
              return '翻仓';
            case 2:
              return '加油';
            case 3:
              return '塔电';
            case 4:
              return '加气';
            case 5:
              return '洗车';
          }
        };
      },
      getSettlement() {
        return function(state) {
          switch (state) {
            case 1:
              return '固定';
            case 2:
              return '比例';
          }
        };
      },
      getContract() {
        return function(state) {
          switch (state) {
            case 1:
              return '固定';
            case 2:
              return '阶梯';
            case 3:
              return '阶梯后返回';
          }
        };
      },
      getState() {
        return function(state) {
          switch (state) {
            case 0:
              return '待生效';
            case 1:
              return '生效中';
            case 2:
              return '已失效';
          }
        };
      },
      getTime() {
        return function(time) {
          return formatDateTime(time, 'yyyy年mm月dd日 hh:ii:ss');
        };
      },
      getCreatTime(val){
        if (val) {
          return formatDateTime(val, "yyyy-mm-dd hh:ii:ss")
        } else {
          return '';
        }
      }
    },
    async mounted() {
      await this._portConfigureInforList();
      await this._getCarSerieList();
      await this._supplierPublicSelectPort();
    },
    methods: {
      //详情-补录合同-删除
      deleteTableClick(id){
        this.$confirm('确认删除当前合同吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await deleteContractInfo(id);
            if (res.status === 0) {
              this.$message.success(res.message);
              await this.detailClick()
            } else {
              this.$message.error(res.message);
            }
          })
          .catch(() => {
          });
        this.companyData.contractData.splice(index, 1);
      },
      async batchEnable() {
        if (this.checkTableData === null || this.checkTableData.length === 0) return this.$message.warning('请选择数据后启用！');
        this.$confirm('确认启用当前选中港口装卸费吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const params = [];
            this.checkTableData.forEach(item => {
              params.push(item.id);
            });
            let res = await supplierPortOtherupdateStatus({
              id: params.join(','),
              status: 1,
            });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.$refs.tableRef.clearSelection();
            this.checkTableData = [];
            await this._portConfigureInforList();
          })
          .catch(() => {
          });
      },
      selectionChange(selectionRow) {
        this.checkTableData = selectionRow;
      },
      async _portConfigureInforList() {
        this.tableLoad = true;
        const res = await supplierPortOtherpageList(
          {
            portName: this.entrustIpt,
            workType: this.typeIpt,
            status: this.stateIpt,
            rows: this.size,
            page: this.page,
          },
        );
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      //适配车型
      async _getCarSerieList() {
        let res = await getCarSerieList();
        if (res.status !== 0) return this.$message.error(res.message);
        this.modelOption = res.data.filter(item => {
          return item.carModel.length != 0;
        });
        this.modelOption = this.modelOption.map(item => {
          item.carModel.forEach((item) => {
            this.modelMap.set(item.id, item.model);
            this.brandMap.set(item.brand_id, item.brand_name);
          });
          return {
            ...item,
            model: item.brand,
          };
        });
      },
      //港口名称
      async _supplierPublicSelectPort() {
        let res = await supplierPublicSelectPort();
        if (res.status !== 0) return this.$message.error(res.message);
        this.nameOption = res.data.map(item => {
          return {
            supplier_name: item.supplier_name,
            id: item.id,
          };
        });
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this._portConfigureInforList();
      },
      contractCurrentChange(page) {
        this.page = page;
        this._portConfigureInforList();
      },
      // 取消
      dialogClose() {
        this.$refs.ruleForm.resetFields();
        this.dialogVisible = false;
      },
      async typeChange() {
        const res = await getTypeInfo(this.companyData.type);
        if (res.status !== 0) return this.$message.error(res.message);
        this.addressOption = res.data.map(item => {
          return {
            id: item.id,
            address: item.address,
          };
        });
      },
      addImgClick() {
        if (!this.companyData.table[this.companyData.table.length - 1].endNum) return this.$message.warning('请先输入结束数量！');
        if (isNaN(Number(this.companyData.table[this.companyData.table.length - 1].endNum))) return this.companyData.table[this.companyData.table.length - 1].endNum = '';
        if (Number(this.companyData.table[this.companyData.table.length - 1].endNum) < Number(this.companyData.table[this.companyData.table.length - 1].startNum)) {
          this.companyData.table[this.companyData.table.length - 1].endNum = '';
          return this.$message.warning('结束数量必须小于开始数量！');
        }
        this.companyData.table.push({ startNum: Number(this.companyData.table[this.companyData.table.length - 1].endNum) + 1 });
      },
      removeClick(index) {
        this.companyData.table.splice(index, 2);
      },
      bjDate(date, date1) {
        var date = new Date(date);
        var date1 = new Date(date1);
        // 减小于0 date<date1
        return date.getTime() - date1.getTime() < 0;
      },
      // 新增/修改 —— 确认
      async addClick() {//区分新增和修改
        let slef = this;
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            if (slef.companyData.start > slef.companyData.end) {
              return this.$message.warning('开始日期不能大于结束日期！');
            }
            for (let z = 0; z < slef.companyData.model.length; z++) {//勾选数组0父级 1子集
              for (let i = 0; i < slef.modelOption.length; i++) {//品牌数据集合
                if (slef.companyData.model[z][0] == slef.modelOption[i].id) {//查找父级数据
                  for (let c = 0; c < this.modelOption[i].carModel.length; c++) {//查找子集数据
                    if (slef.companyData.model[z][1] == slef.modelOption[i].carModel[c].id) {
                      let mo = {
                        brandId: this.modelOption[i].id,
                        brandName: this.modelOption[i].brand,
                        modelId: this.modelOption[i].carModel[c].id,
                        modelName: this.modelOption[i].carModel[c].model,
                      };
                      slef.carModelSz.push(mo);
                    }
                  }
                }
              }
            }
            if (slef.companyData.money <= 0) {
              return this.$message.warning('错误费用不能小于0！');
            } else if (slef.companyData.number <= 0) {
              return this.$message.warning('汽车数量不能小于0！');
            } else if (slef.companyData.rate <= 0) {
              return this.$message.warning('税率不能小于0！');
            }
            let object = {};
            //调用新增接口
            if (slef.type == 1) {//新增
              object = {
                portId: slef.companyData.name.id,
                workType: slef.companyData.taskType,
                startDate: slef.companyData.start,
                endDate: slef.companyData.end,
                taxRate: slef.companyData.rate,
                unitPrice: slef.companyData.money,
                carModelList: slef.carModelSz,
              };
              const res = await supplierPortOtheradd(object);
              if (res.status !== 0) return this.$message.error(res.message);
              this.$message.success(res.message);
            } else if (slef.type == 2) {//修改
              object = {
                id: slef.zbId,
                portId: slef.companyData.name.id,
                workType: slef.companyData.taskType,
                startDate: slef.companyData.start,
                endDate: slef.companyData.end,
                taxRate: slef.companyData.rate,
                unitPrice: slef.companyData.money,
                carModelList: slef.carModelSz,
              };
              const res = await supplierPortOtherupdate(object);
              if (res.status !== 0) return this.$message.error(res.message);
              this.$message.success(res.message);
            }
            this.dialogVisible = false;
            this._portConfigureInforList();
          }
        });
      },
      nameChange() {
        debugger;
        if (this.companyData.taskType == 1 || this.companyData.taskType == 5) {
          this.company = '辆';
        } else if (this.companyData.taskType == 2 || this.companyData.taskType == 4) {
          this.company = '升';
        } else if (this.companyData.taskType == 3) {
          this.company = '度';
        }
      },
      carClick() {
        this.carVisible = true;
        this.selectCar = [...this.selectedCar];
        this.brands = [...this.brands2];
        this.models = [...this.models2];
      },
      selectRemove(item) {
        this.selectCar.splice(this.selectCar.indexOf(item), 1);
        if (this.brands.indexOf(item) !== -1) {
          this.brands.splice(this.brands.indexOf(item), 1);
        } else {
          this.models.splice(this.models.indexOf(item), 1);
        }
      },
      brandAdd(item) {
        if (this.selectCar.indexOf(item) !== -1) return this.$message.warning('已选择该品牌！');
        let arr = [];
        for (let i = 0; i < this.allCar.length; i++) {
          if (this.allCar[i].id === item.id) {
            arr = this.allCar[i].carModel;
            break;
          }
        }
        for (let i = 0; i < arr.length; i++) {
          for (let j = 0; j < this.selectCar.length; j++) {
            if (arr[i].id === this.selectCar[j].id) {
              this.selectCar.splice(j, 1);
              j--;
            }
          }
        }
        this.selectCar.push(item);
        this.brands.push(item);
      },
      modelAdd(item) {
        for (let i = 0; i < this.selectCar.length; i++) {
          if (this.selectCar[i].id === item.brandId) {
            return this.$message.warning('上方已选择该品牌的全部车型！');
          } else if (this.selectCar[i].id === item.id) return this.$message.warning('已选择该车型！');
        }
        this.selectCar.push(item);
        this.models.push(item);
      },
      carAddClick() {
        this.carVisible = false;
        this.selectedCar = [...this.selectCar];
        this.brands2 = [...this.brands];
        this.models2 = [...this.models];
      },
      carClose() {
        this.carVisible = false;
      },
      brandClick(id) {
        for (let i = 0; i < this.allCar.length; i++) {
          if (this.allCar[i].id === id) {
            this.selectModel = this.allCar[i].carModel.map(item => {
              return {
                id: item.id,
                name: item.brand_name,
                brandId: item.brand_id,
              };
            });
            break;
          }
        }
      },
      // 删除
      deleteClick(id) {
        this.$confirm('确认删除当前港口其它费吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await supplierPortOtherdelete(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._portConfigureInforList();
          })
          .catch(() => {
          });
      },
      // 启用
      enableClick(row) {
        debugger;
        this.$confirm('确认启用当前港口装卸费吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await supplierPortOtherupdateStatus({
              id: row.id,
              status: 1,
            });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._portConfigureInforList();
          })
          .catch(() => {
          });
      },
      // 停用
      disableClick(row) {
        this.$confirm('确认停用当前港口装卸费吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await supplierPortOtherupdateStatus({
              id: row.id,
              status: 2,
            });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._portConfigureInforList();
          })
          .catch(() => {
          });
      },
      // 对象数组排序
      compare(property) {
        return (a, b) => {
          let value1 = a[property];
          let value2 = b[property];
          return value1 - value2;
        };
      },
      // 详情
      async detailClick(id) {
        const res = await supplierPortOtherdetail(id);
        this.supplier_name = res.data.portName;
        this.company = res.data.unit;
        this.companyData = {
          model: res.data.customerCarName,
          taskTypes: res.data.workType,
          starts: res.data.startDate,
          ends: res.data.endDate,
          rate: res.data.taxRate,
          money: res.data.unitPrice,
          modelLists: res.data.carModelList,
          operateRecordList: res.data.operateRecordList,
        };
        const res1 = await getContractInfo(id);
        if (res1.status !== 0) return this.$message.error(res1.message);
        this.companyData.contractData = res1.data;
        this.detailDialogVisible = true;
      },
      // 修改
      async changeClick(row) {
        this.companyData.model = [];
        this.carModelSz = [];
        this.dialogTitle = '修改港口价格';
        this.zbId = row.id;
        this.type = 2;
        this.dialogVisible = true;
        const res = await supplierPortOtherdetail(row.id);
        debugger;
        var idList = [];
        //循环拼接适配器车
        for (let i = 0; i < res.data.carModelList.length; i++) {
          let modelId = [res.data.carModelList[i].brandId, res.data.carModelList[i].modelId];
          idList.push(modelId);
        }
        this.company = res.data.unit;
        this.companyData = {
          name: {
            id: res.data.portId,
          },
          model: idList,
          taskType: res.data.workType,
          start: res.data.startDate,
          end: res.data.endDate,
          rate: res.data.taxRate,
          money: res.data.unitPrice,
        };

      },
      searchBtn() {
        this.page = 1;
        this._portConfigureInforList();
      },
      // 新增
      addBtn() {
        debugger;
        this.dialogTitle = '添加港口价格';
        this.type = 1;
        this.dialogVisible = true;
        this.company = '';
        this.companyData = {
          way: 0,
          method: 1,
          contract: 1,
          table: [
            { startNum: 0 },
          ],
        };
        this.companyData.model = [];
        this.carModelSz = [];
        // this._getCarSerieList()
        // this._supplierPublicSelectPort()
      },
      // 重置
      resetBtn() {
        this.entrustIpt = '';
        this.typeIpt = '';
        this.stateIpt = '';
      },

      // 时间长度处理
      getDate(row, column, cellValue) {
        if (cellValue) {
          return cellValue.substring(0, 10);
        } else {
          return '';
        }
      },
      // 结算价格设置 —— 分页查询
      async _contractPageList() {
        let obj = {
          ...this.condition,
          page: this.page1,
          rows: this.rows1,
        };
        this.contractLoad = true;
        let res = await contractPageList(obj);
        this.contractLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.contractData = res.data;
        this.total1 = res.data.total || 0;
        if (this.companyData.companyId && this.contractData.length > 0) {
          this.contractData.forEach(item => {
            if (item.id == this.companyData.companyId) {
              this.$refs.contractTable.setCurrentRow(item);
            }
          });
        }
      },
      // 结算价格设置 —— 重置
      resetBtn1() {
        for (let key in this.condition) {
          this.condition[key] = '';
        }
      },
      contractSizeChange1(rows) {
        this.rows1 = rows;
        this._contractPageList();
      },
      contractCurrentChange1(page) {
        this.page1 = page;
        this._contractPageList();
      },
      // 结算价格设置 —— 选中合同
      contractChange(val) {
        this.selectContract = val;
      },
    },
  };
</script>


<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-top: 30px;
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-badge__content {
            top: 4px !important;
            right: 1px !important;
          }

          .el-badge__content {
            background-color: #F56C6C !important;
          }

          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .carContainer {
      width: 100%;
      padding: 15px 40px 10px 20px;
      max-height: 75vh;
      overflow: auto;

      &Title {
        display: flex;
        flex-direction: column;

        span {
          color: #101010;
          font-weight: 700;
          margin-bottom: 5px;
        }

        &Content {
          width: 100%;
          padding-left: 15px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          margin-bottom: 10px;

          &Item {
            height: 25px;
            padding: 0 5px;
            background-color: #a4adb3;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-right: 10px;
            margin-bottom: 5px;

            i {
              color: #000;
              font-size: 17px;
              cursor: pointer;
            }

            p {
              cursor: pointer;
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 80vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            ::v-deep {
              .el-table td, .el-table th {
                padding: 0;
              }

              .cell {
                font-size: 10px;
                padding: 0;
              }
            }

            .imgContainer {
              display: flex;
              align-items: center;
            }

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td, .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    .reasonContainer {
      width: 100%;
      padding: 20px 30px;

      ::v-deep {
        .el-textarea__inner {
          min-height: 100px !important;
        }
      }

      .reasonBtn {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }

    .depart {
      width: 100%;
      padding: 10px 20px 10px 20px;
      max-height: 70vh;
      overflow: auto;

      .specialItem {
        ::v-deep {
          .el-form-item__content {
            margin-left: 0 !important;
          }
        }
      }

      .model-item {
        ::v-deep {
          .el-form-item__error {
            top: 80%;
          }
        }
      }

      ::v-deep {
        .el-table td, .el-table th {
          padding: 0;
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }

        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item {
          margin-bottom: 10px;
        }

        .el-cascader.el-cascader--mini {
          margin-bottom: 13px;

          input.el-input__inner {
            height: 32px !important;
          }
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          position: relative;
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  ::v-deep {
    .el-table__body tr.current-row > td {
      background-color: #409eff;
      color: #fff !important;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }
  }

  .price-window {
    ::v-deep {
      .el-dialog__body {
        padding: 30px 20px 20px;
        max-height: 70vh;
        overflow-y: auto;
      }

      .cell .el-form-item {
        padding: 0 2px;
      }

      .el-table td, .el-table th {
        padding: 3px 0;
      }

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
        text-align: center;
      }

      .el-dialog__title {
        color: #fff;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
      }
    }

    .navBtn {
      display: inline-block;
      width: calc(100% - 690px);
      text-align: right;
      margin-bottom: 10px;
    }

    .price-set {
      color: #3187ff;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .set-up {
    color: #3187ff;
    position: absolute;
    padding-right: 10px;
    height: 24px;
    line-height: 24px;
    right: 10px;
    top: calc(50% - 12px);
    text-decoration: underline;
    cursor: pointer;
  }

  .navContainer {
    display: inline-block;
    width: 230px;
    text-align: center;

    p {
      display: inline-block;
      width: 70px;
    }
  }
</style>
